import styled, { css } from 'styled-components'

import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const BreadcrumbsWrapper = styled.div`
    max-width: 1170px;
    margin: 0 auto;
    ${(props) => props.theme.typo.bodyS}
    color: ${(props) => props.theme.color.black};
    padding: 15px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 20px 0;
    }
`

const ellipsis = css`
    max-width: 300px;
    text-overflow: ellipsis;
    overflow: hidden;
    text-wrap: nowrap;
    display: inline-block;
    vertical-align: middle;
`

export const BreadcrumbLink = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyS}
    color: ${(props) => props.theme.color.black};
    text-decoration: none;

    ${ellipsis}

    &:hover {
        text-decoration: underline;
    }
`

export const BreadcrumbActive = styled.span`
    color: ${(props) => props.theme.color.g500};
    ${ellipsis}
`
